module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-nuts.c19dc21c.svg";